import { httpClient } from "@/services";
import { trimLeadingDisabledWeek } from "@/helper";

export default {
	state: {
		userProfile_user: null,
		userProfile_duties: null,
		userProfile_calendar: null,
		userProfile_managers: null,
		userProfile_month: null,
		userProfile_month_calendar: null,
		userProfile_overtime: null,
		userProfile_total_schedule_time: null,
		userProfile_total_work_time: null,
		userProfileMyInfo: null,
		userPayРistory_months: null,
		userPayРistory_rows: null,
		userPayРistory_first: null,
		userProfile_month_info: null,
		userProfile_department: null,
	},
	mutations: {
		updateUserProfileInfo(state, payload) {
			const { user, calendar, managers, month, month_calendar, overtime, total_schedule_time, total_work_time, month_info, duties, department, } = payload;
			state.userProfile_user = user;
			state.userProfile_duties = duties;
			state.userProfile_calendar = trimLeadingDisabledWeek(calendar);
			state.userProfile_managers = managers;
			state.userProfile_month = month;
			state.userProfile_month_calendar = month_calendar;
			state.userProfile_overtime = overtime;
			state.userProfile_total_schedule_time = total_schedule_time;
			state.userProfile_total_work_time = total_work_time;
			state.userProfile_month_info = month_info;
			state.userProfile_department = department;
		},
		updateUserProfileMyInfo(state, payload) {
			state.userProfileMyInfo = payload;
		},
		updateUserPayРistory(state, payload) {
			const { months, rows } = payload;

			state.userPayРistory_months = months;
			state.userPayРistory_rows = rows;
		},
		updateUserPayРistoryFirst(state, payload) {
			const { rows } = payload;

			state.userPayРistory_first = rows;
		},
		deleteUserSalaryPayment(state, payload) {
			const { id, data } = payload;
			const { rows } = data;

			// Проверяем и удаляем объект с id = delId
			Object.keys(rows).forEach(key => {
				if (rows[key].salary_payment) {
					rows[key].salary_payment = rows[key].salary_payment.filter(item => item.id !== id);
				}
			});

			state.userPayРistory_first = rows;
		},
	},
	actions: {
		async getUserEditTime({ dispatch }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { id, args } = values;
				const { data } = await httpClient.post(`/info/users/date-time/${ values.date }/${ id }`, args );
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message: "Data successfully updated 👌" });
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getUserProfileInfo({ dispatch, commit }, id ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/info/users/${ id }/edit` );
				if (data && !data.status) {
					commit('updateUserProfileInfo', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getUserUpdateCalendar({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { id, date, type } = values;
				const { data } = await httpClient.post(`/info/users/${ id }/edit`, { date });
				if (data && !data.status) {
					commit('updateUserProfileInfo', data);
					if ( type === 'comments' ) {
						dispatch('setAlert', { type: "success", message: "📤 Message has been sent successfully." });
					}
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getUserProfileMyInfo({ dispatch, commit }, id ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get(`/info/my-information/${ id }/edit/` );
				if (data && !data.status) {
					commit('updateUserProfileMyInfo', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		
		async getUserPayРistory({ dispatch, commit }, id ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/info/pay-history/${ id }` );

				if (data) {
					commit('updateUserPayРistory', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getUserPayРistoryPrev({ dispatch }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { id, date } = values;
				const { data } = await httpClient.post(`/info/pay-history/${ id }`, { date } );

				// if (data) {
				// 	commit('updateUserPayРistoryPrev', data);
				// } else {
				// 	dispatch('setAlert', { type: "error", message: "Server Error" });
				// }
				dispatch('actionPreloader', false);

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async getUserSalaryPay({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/info/pay-history`, values );

				if (data) {
					commit('updateUserPayРistoryFirst', data);
					dispatch('setAlert', { type: "success", message: "Data successfully updated 👌" });
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);

			} catch (e) {
				console.error(e);
			}
		},
		async deleteUserSalaryPayment({ dispatch, commit }, id) {
			try {
				const { data } = await httpClient.delete(`/info/pay-history/${ id }`);
				if (data && data.status) {
					commit('deleteUserSalaryPayment', { id, data });
					dispatch('setAlert', { type: "success", message: "Salary payment deleted successfully 🗑️" });
				}
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		userProfile_user: s => s.userProfile_user,
		userProfile_duties: s => s.userProfile_duties,
		userProfile_calendar: s => s.userProfile_calendar,
		userProfile_managers: s => s.userProfile_managers,
		userProfile_month: s => s.userProfile_month,
		userProfile_month_calendar: s => s.userProfile_month_calendar,
		userProfile_overtime: s => s.userProfile_overtime,
		userProfile_total_schedule_time: s => s.userProfile_total_schedule_time,
		userProfile_total_work_time: s => s.userProfile_total_work_time,
		userProfile_month_info: s => s.userProfile_month_info,
		userProfileMyInfo: s => s.userProfileMyInfo,
		userPayРistory_months: s => s.userPayРistory_months,
		userPayРistory_rows: s => s.userPayРistory_rows,
		userPayРistory_first: s => s.userPayРistory_first,
		userProfile_department: s => s.userProfile_department,
	}
};
